import * as React from 'react';
import styles from './index.less';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import { Modal, Space } from 'antd';
import FCoverImage from '@/components/FCoverImage';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import FIcons from '@/components/FIcons';

interface FBatchHandleResource_ResultModal_Props {
  type: 'online' | 'offline' | 'addPolicy' | 'signNode';
  dataSource: {
    [k: string]: {
      data: string;
      status: 1 | 2;
    };
  };

  onClose?(): void;
}

function FBatchHandleResource_ResultModal({
  type,
  dataSource,
  onClose,
}: FBatchHandleResource_ResultModal_Props) {
  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>(true);
  const [$succeedCount, set$succeedCount, get$succeedCount] =
    FUtil.Hook.useGetState<number>(0);
  const [$failedList, set$failedList, get$failedList] = FUtil.Hook.useGetState<
    {
      cover: string;
      resourceID: string;
      resourceName: string;
      resourceTitle: string;
      resourceType: string;
      failedReason: string;
    }[]
  >([]);

  AHooks.useDebounceEffect(
    () => {
      handledData();
    },
    [dataSource],
    {
      wait: 30,
    },
  );

  async function handledData() {
    if (!dataSource) {
      set$succeedCount(0);
      set$failedList([]);
      return;
    }
    const succeedCount = Object.values(dataSource).filter((d) => {
      return d.status === 1;
    }).length;
    set$succeedCount(succeedCount);
    const failedResourceIDs: string[] = Object.entries(dataSource)
      .filter((d) => {
        return d[1].status === 2;
      })
      .map((d) => {
        return d[0];
      });
    if (failedResourceIDs.length > 0) {
      const { data }: { data: any[] } = await FServiceAPI.Resource.batchInfo({
        resourceIds: failedResourceIDs.join(','),
      });
      // console.log(data, 'data sdifjalskdjflsdjlkfjlksdjlkj');

      set$failedList(
        data.map((d) => {
          return {
            cover: d.coverImages[0],
            resourceID: d.resourceId,
            resourceName: d.resourceName,
            resourceTitle: d.resourceTitle,
            resourceType: d.resourceType.join('/'),
            failedReason: dataSource[d.resourceId].data,
          };
        }),
      );
    }
  }

  return (
    <Modal
      open={$open}
      title={null}
      footer={null}
      centered={true}
      width={800}
      styles={{
        body: {
          padding: '50px 60px 40px',
          borderRadius: 10,
        },
      }}
      style={{
        borderRadius: 10,
        overflow: 'hidden',
      }}
      onCancel={() => {
        set$open(false);
        // onClose && onClose();
      }}
      afterClose={() => {
        onClose && onClose();
      }}
    >
      {$succeedCount > 0 && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 15,
            fontSize: 14,
            fontWeight: 600,
            color: '#42C28C',
            flexDirection: 'column',
          }}
        >
          {type === 'online' && (
            <>
              <FIcons.FUpcast
                style={{
                  fontSize: 64,
                  color: '#42C28C',
                }}
              />
              {/*<div>成功上架{$succeedCount}个资源</div>*/}
              <div>
                {FI18n.i18nNext.tAuto(
                  'myresources_bulkaction_msg_availabletoauth_done',
                  {
                    Qty: $succeedCount,
                  },
                )}
              </div>
            </>
          )}

          {type === 'offline' && (
            <>
              <FIcons.FUpcast
                style={{
                  fontSize: 64,
                  color: '#42C28C',
                  transform: 'rotate(180deg)',
                }}
              />
              <div>成功下架{$succeedCount}个资源</div>
            </>
          )}

          {type === 'addPolicy' && (
            <>
              <FIcons.FCheck
                style={{
                  fontSize: 64,
                  color: '#42C28C',
                }}
              />
              <div>
                {FI18n.i18nNext.tAuto(
                  'myresources_bulkaction_msg_addauthplan_done',
                  {
                    Qty: $succeedCount,
                  },
                )}
              </div>
            </>
          )}

          {type === 'signNode' && (
            <>
              <FIcons.FUpcast
                style={{
                  fontSize: 64,
                  color: '#42C28C',
                }}
              />
              <div>成功添加{$succeedCount}个资源</div>
            </>
          )}
        </div>
      )}

      {$succeedCount > 0 && $failedList.length > 0 && (
        <div style={{ height: 50 }} />
      )}

      {$failedList.length > 0 && (
        <>
          {type === 'online' && (
            <FComponentsLib.FContentText
              type={'negative'}
              // text={'以下资源上架失败：'}
              text={FI18n.i18nNext.tAuto(
                'myresources_bulkaction_msg_availabletoauth_failure',
              )}
            />
          )}

          {type === 'offline' && (
            <FComponentsLib.FContentText
              type={'negative'}
              text={'以下资源下架失败：'}
            />
          )}

          {type === 'addPolicy' && (
            <FComponentsLib.FContentText
              type={'negative'}
              text={FI18n.i18nNext.tAuto(
                'myresources_bulkaction_msg_addauthplan_failure',
              )}
            />
          )}

          {type === 'signNode' && (
            <FComponentsLib.FContentText
              type={'negative'}
              text={'以下资源添加失败：'}
            />
          )}

          <div style={{ height: 20 }} />
          <div style={{ maxHeight: 260, overflowY: 'auto', paddingRight: 10 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                gap: 5,
              }}
            >
              {$failedList.map((v) => {
                return (
                  <div
                    key={v.resourceID}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      height: 68,
                      // borderBottom: '1px solid #E5E7EB',
                      background: 'rgba(0,0,0,0.03)',
                      borderRadius: 10,
                      padding: '0 10px',
                    }}
                  >
                    <Space size={10}>
                      <FCoverImage
                        src={v.cover}
                        width={64}
                        style={{ borderRadius: 4 }}
                      />
                      <div>
                        <FComponentsLib.FContentText
                          type={'highlight'}
                          text={v.resourceTitle || v.resourceName.split('/')[1]}
                          singleRow
                          style={{ maxWidth: 400 }}
                        />
                        <div style={{ height: 10 }} />
                        <FComponentsLib.FContentText
                          type={'additional2'}
                          text={v.resourceType}
                          singleRow
                          style={{ maxWidth: 400 }}
                        />
                      </div>
                    </Space>

                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={v.failedReason}
                      style={{ color: '#EE4040' }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}

      <div style={{ height: 40 }} />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <FComponentsLib.FRectBtn
          onClick={() => {
            set$open(false);
          }}
        >
          {FI18n.i18nNext.tAuto('myresources_bulkaction_btn_ok')}
        </FComponentsLib.FRectBtn>
      </div>
    </Modal>
  );
}

export default FBatchHandleResource_ResultModal;
